import { Paginated, makePaginated } from "../../adl-gen/common";
import { WithDbId, DbKey, makeWithDbId } from "../../adl-gen/common/db";
import { TableQuery } from "../../adl-gen/common/tabular";
import { RecommendationMethod, Skill, SkillTrainingOffering, TrainingOffering, makeSkillTrainingOffering } from "../../adl-gen/totalinteraction/futurefit/db";
import { Service } from "../../service/service";
import { LoggedIn, LoggedInSuper } from "../../stores/identity-store";

import { DataStore, TransportLayer } from "./datastore";

export type SkillTrainingOfferingChange =
  | {
      kind: 'loaded' | 'update';
      id: DbKey<SkillTrainingOffering>;
      skillId: DbKey<Skill>;
      trainingOfferingId: DbKey<TrainingOffering>;
      method: RecommendationMethod;
    }
  | {
      kind: 'create';
      // dummy id - required for use in ListView
      id: string;
      skillId: DbKey<Skill>;
      trainingOfferingId: DbKey<TrainingOffering>;
      method: RecommendationMethod;
    }
  | {
      kind: 'delete';
      id: DbKey<SkillTrainingOffering>;
    };

class SkillTrainingOfferingApi implements TransportLayer<SkillTrainingOffering> {
  kind: string = 'SkillTrainingOffering';
  constructor(protected readonly service: Service) {}
  query = async (_q: TableQuery): Promise<Paginated<WithDbId<SkillTrainingOffering>>> => {
    // Not implemented
    return makePaginated({ items: [], current_offset: 0, total_size: 0 });
  };

  create = async (sto: SkillTrainingOffering): Promise<DbKey<SkillTrainingOffering>> =>
    this.service.createSkillTrainingOffering(sto);
  update = async (sto: WithDbId<SkillTrainingOffering>): Promise<void> =>
    this.service.updateSkillTrainingOffering(sto);
  doDelete = async (sto: DbKey<SkillTrainingOffering>): Promise<void> =>
    this.service.deleteSkillTrainingOffering(sto);
}

// This is not meant to be a store; just a common conduit for TrainingOfferings and Skills
// So no constructor or observables etc
export class SkillTrainingOfferingHelper extends DataStore<SkillTrainingOffering> {
  static fromService = (
    service: Service,
    identity: LoggedIn | LoggedInSuper,
    id?: DbKey<SkillTrainingOffering>
  ): SkillTrainingOfferingHelper => {
    const store = new SkillTrainingOfferingHelper(new SkillTrainingOfferingApi(service), identity, id);
    return store;
  };

  public updateSkillTrainingOfferings = async (updates: SkillTrainingOfferingChange[]): Promise<void> => {
    if (this.authorized) {
      await Promise.all(
        updates.map(async change => {
          switch (change.kind) {
            case 'create':
              return this.create(
                makeSkillTrainingOffering({
                  skillId: change.skillId,
                  trainingOfferingId: change.trainingOfferingId,
                  method: change.method
                })
              );
            case 'update':
              return this.update(
                makeWithDbId({
                  id: change.id,
                  value: makeSkillTrainingOffering({
                    skillId: change.skillId,
                    trainingOfferingId: change.trainingOfferingId,
                    method: change.method
                  })
                })
              );
            case 'delete':
              return this.doDelete(change.id);
            default:
              // loaded - do nothing
              return Promise.resolve();
          }
        })
      );
    } else {
      return Promise.reject('Not authorized');
    }
  };

  // Override to avoid the 'deferRefresh' thing
  create = async (
    sto: SkillTrainingOffering
  ): Promise<DbKey<SkillTrainingOffering>> => {
    if (this.authorized) {
      const id = await this.transport.create(sto);
      return id;
    } else {
      return Promise.reject('Not authorized');
    }
  };

  update = async (sto: WithDbId<SkillTrainingOffering>): Promise<void> => {
    if (this.authorized) {
      await this.transport.update(sto);
    } else {
      return Promise.reject('Not authorized');
    }
  };

  doDelete = async (sto: DbKey<SkillTrainingOffering>): Promise<void> => {
    if (this.authorized) {
      await this.transport.doDelete(sto);
    } else {
      return Promise.reject('Not authorized');
    }
  };
}




// WEBPACK FOOTER //
// ./src/admin/stores/skill-training-offering-helper.ts